const LINK_KIND_OPTIONS = [
    { label: "Call", value: "call" },
    { label: "Service request", value: "book" },
    { label: "Get a quote", value: "quote" },
    { label: "Leave a review", value: "review" },
    { label: "Directions", value: "directions" },
    { label: "See our work", value: "gallery" },
    { label: "Custom link", value: "custom" },
  ],

  LinksPageFields = {
    logoUrl: {
      type: "text",
      label: "Logo URL",
      metadata: {
        source: "data",
        description: "Logo shown at the top of the link page; seeded from the site's logo",
        key: "linksPage.logoUrl",
      },
    },
    tagline: {
      type: "text",
      label: "Tagline",
      metadata: {
        source: "manual",
        description: "One line under the business name; blank shows the city and state",
      },
    },
    links: {
      type: "array",
      label: "Links",
      metadata: {
        source: "data",
        description:
          "Ordered link rows. Auto kinds resolve their target from live business data; delete a row to hide it, add one to bring it back.",
        key: "linksPage.links",
      },
      getItemSummary: (item: { kind?: string; label?: string }) =>
        item.label?.trim() ||
        LINK_KIND_OPTIONS.find((option) => option.value === item.kind)?.label ||
        "Link",
      arrayFields: {
        kind: {
          type: "select",
          label: "Type",
          options: LINK_KIND_OPTIONS,
          metadata: {
            description: "What this row does; every type except Custom resolves its own URL",
          },
        },
        label: {
          type: "text",
          label: "Label (optional)",
          metadata: {
            description: "Override the default button text",
          },
        },
        url: {
          type: "text",
          label: "URL (optional)",
          metadata: {
            description:
              "Blank fills in automatically from your business. Set it to send this link somewhere else. Custom links always need one.",
          },
        },
      },
      defaultItemProps: {
        kind: "custom",
        label: "",
        url: "",
      },
    },
    photos: {
      type: "array",
      label: "Photos",
      metadata: {
        source: "data",
        description:
          "Photo grid under the link rows. Each photo can carry a caption and optionally link somewhere.",
        key: "linksPage.photos",
      },
      getItemSummary: (item: { caption?: string }) => item.caption?.trim() || "Photo",
      arrayFields: {
        imageUrl: {
          type: "custom",
          label: "Photo",
          metadata: {
            source: "manual",
            description: "The picture to show",
          },
        },
        caption: {
          type: "text",
          label: "Caption (optional)",
          metadata: {
            source: "manual",
            description: "One short line under the photo",
          },
        },
        url: {
          type: "text",
          label: "Link (optional)",
          metadata: {
            source: "manual",
            description: "Where tapping the photo goes; blank means it is just a photo",
          },
        },
      },
      defaultItemProps: {
        imageUrl: "",
        caption: "",
        url: "",
      },
    },
    showRating: {
      type: "radio",
      label: "Show Google rating",
      options: [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
      metadata: {
        source: "manual",
        description: "Star rating and review count from the connected Google Business Profile",
      },
    },
    showSocials: {
      type: "radio",
      label: "Show social profiles",
      options: [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
      metadata: {
        source: "manual",
        description: "Icon row for the social profiles saved on the business",
      },
    },
  } as const;

export { LinksPageFields };
